const WorkingCapital = () => import(/* webpackChunkName: "workingCapital" */ './WorkingCapital.vue')

const index = {
  path: 'working/capital',
  name: 'Working Capital',
  component: WorkingCapital,
  meta: {
    requiresLogin: true,
    requiresCompany: true,
    permissions: []
  }
}

export default {
  index
}
